module.exports = __webpack_public_path__ + "img/08.22.49.7c8d6948.jpg";